import {List, Record} from "immutable";
import {ApplicationState} from "../../reducer";
import {BoardModel, BoardSync} from "../model";
import {BoardHistory} from "../model/HistoryEntry";
import {HistoryState} from "../model/HistoryState";

const getBoardHistoryById = (state: Record<ApplicationState>, boardId: BoardModel.BoardId): HistoryState => state.getIn(['inspectioBoards', 'history', boardId]) || new HistoryState();

export const makeBoardHistoryByIdSelector = (boardId: BoardModel.BoardId): (state: Record<ApplicationState>) => HistoryState => (state: Record<ApplicationState>) => getBoardHistoryById(state, boardId);